import { memo } from 'react';

import { SearchSubSideNavItem } from '~/components/v2/components/workspace/search-nav/item/SearchSubSideNavItem';
import { SEARCH_NESTED_NAV_ITEMS } from '~/components/v2/components/workspace/search-nav/searchNavItems';

export const SearchSubSideNavItems = memo(() => {
  return (
    <div className="flex flex-col">
      {SEARCH_NESTED_NAV_ITEMS.map((item) => (
        <SearchSubSideNavItem className="pl-[18px]" item={item} key={item.id} />
      ))}
    </div>
  );
});

SearchSubSideNavItems.displayName = 'SearchSubSideNavItems';
